import React, { FC } from "react";
import { PAYMENT_STATUS } from "../../../utils";
import {
  CompletedIcon,
  FailedIcon,
  LoadingIcon,
  PendingIcon,
} from "../invoice/icons";
import { useTranslation } from "react-i18next";

type Props = {
  text: string;
  icon?: React.ReactNode;
  background: string;
  textStyle: string;
};

export const PaymentStatus: FC<Props> = ({
  text,
  icon,
  background,
  textStyle,
}) => {
  return (
    <div
      className={`rounded ${background} px-2 py-1 text-center d-flex align-items-center justify-content-center w-fit-content`}
    >
      {icon}
      <span className={`d-none d-md-inline ms-2 fs-7 ${textStyle}`}>
        {text}
      </span>
    </div>
  );
};

export const GetStatus = ({ status }: { status: number }) => {
  const { t } = useTranslation();

  if (status === PAYMENT_STATUS.FAILED) {
    return (
      <PaymentStatus
        text={t("payment.Failed")}
        icon={<FailedIcon />}
        background="bg-danger-light"
        textStyle="text-danger"
      />
    );
  } else if (status === PAYMENT_STATUS.PENDING) {
    return (
      <PaymentStatus
        text={t("payment.Pending")}
        icon={<PendingIcon />}
        background="bg-blue-light"
        textStyle="text-blue-info"
      />
    );
  } else if (
    status === PAYMENT_STATUS.COMPLETED ||
    status === PAYMENT_STATUS.CANCELED
  ) {
    return (
      <PaymentStatus
        text={t("payment.Completed")}
        icon={<CompletedIcon />}
        background="bg-success-light"
        textStyle="text-success"
      />
    );
  } else if (status === PAYMENT_STATUS.LOADING) {
    return (
      <PaymentStatus
        text={t("profile.loading")}
        icon={<LoadingIcon />}
        background="bg-blue-light"
        textStyle="text-blue-info"
      />
    );
  }
};
